export default {
  YOLA_DEBUGGING: 'YOLA_DEBUGGING',
};
